

<template>
	<div class="st-main-content">
		<common-search-form ref="commonSearch" :formOptions="formOptions" @onSearch="onSearch"></common-search-form>

		<div class="data-table-box">
			<common-table ref="CommonTableRef" :tableColumns="tableColumns" :data="dataList" :loading="loading"
				:showPage="togglePage" :pageConfig="pageConfig" :bottomHandleArr="bottomHandleArr"
				@selectionChange="selectionChange" @currentChange="currentChange" @sizeChange="sizeChange">
				<template v-slot:imgUrls="{row}">
					<div v-if="row.imgUrls.length == 0">暂无图片</div>
					<div v-else>
						<img class="smallImg" :src="getFirstImg(row.imgUrls)" @click.stop="showAllImg(row.imgUrls)" />
					</div>
				</template>
			</common-table>
		</div>
		<div class="previewImg" v-if="toggleImg">
			<img @click="toggleImg = false" class="closeImg" src="../../assets/images/close.png" alt="" />
			<div class="previewImgWarp">
				<div class="mypreviewImg">
					<img :src="previewPath" />
				</div>
			</div>
		</div>

		<!-- 查看上传的商品图 
            <el-dialog>
                <el-carousel :interval="4000" type="card" height="200px">
                    <el-carousel-item v-for="item in previewList" :key="item">
                        <img :src="item"></img>
                    </el-carousel-item>
                </el-carousel>
            </el-dialog>
        -->


		<!--商品的维护的处理-->
		<el-dialog id="productDialog" title="新增/编辑商品" :visible.sync="showProductDialog" width="800px" center
			@close="toCloseProductDialog" :close-on-click-modal="false">
			<el-form :model="productForm" ref="productForm" :rules="productFormRule" label-width="120px">
				<el-form-item label="商品名称" prop="goodsName">
					<el-input v-model="productForm.goodsName" placeholderf="请输入商品名称"></el-input>
				</el-form-item>
				<!-- 这里的prop仅仅用于检验 -->
				<el-form-item label="商品图片" prop="goodsName">
					<div class="wrapper">
						<el-upload style="margin-top:42rpx" action="http://192.168.101.214:8080/api/file//upload"
							list-type="picture-card" :on-preview="handlePictureCardPreview" :on-remove="handleRemove"
							:file-list="fileList" :http-request="bannerUpload" :limit="9">
							<i class="el-icon-plus"></i>
							<div slot="tip">可上传多张，最多九张，至少上传一张,尺寸：1:1 ，800px * 800px</div>
						</el-upload>
						<el-dialog :visible.sync="dialogVisible">
							<img width="100%" :src="dialogImageUrl" alt="" />
						</el-dialog>
					</div>
				</el-form-item>
				<!-- 在这部分加上店铺的id与分类的id -->
				<!-- <el-form-item label="所属店铺" prop="shopId" placeholder="请选择所属店铺">
					<el-select v-model="productForm.shopId" @change="getClassByShopId">
						<el-option v-for="(item, index) in shopList" :key="index" :label="item.shopName"
							:value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="所属店铺分类" prop="classId" placeholder="请选择所属店铺分类">
					<el-select v-model="productForm.classId">
						<el-option v-for="(item, index) in classList" :key="index" :label="item.className"
							:value="item.id"></el-option>
					</el-select>
				</el-form-item> -->
				<el-form-item label="市场价(￥)" prop="marketPrice">
					<el-input v-model="productForm.marketPrice" type="text"></el-input>
				</el-form-item>
				<!-- 原来的优惠价字段 -->
				<el-form-item label="销售价(￥)" prop="discountPrice">
					<el-input v-model="productForm.discountPrice" type="text"
						@change="(val)=>setScoreDeduction(val,'discountPrice')"></el-input>
				</el-form-item>

				<fieldset class="activity-content">
					<legend>积分活动</legend>
					<!-- 积分换购价  2021-07-30 增加，-->
					<el-form-item label="积分换购价(￥)" prop="discountPriceNew">
						<el-input v-model="productForm.discountPriceNew" type="text"
							@change="(val)=>setScoreDeduction(val,'discountPriceNew')"></el-input>
					</el-form-item>
					<el-form-item label="所需积分" prop="needScore">
						<el-input v-model="productForm.needScore" type="text" @input="
                                val => {
                                    setInt(val, 'needScore');
                                }
                            "></el-input>
					</el-form-item>
					<el-form-item label="积分抵扣(￥)" prop="scoreDeduction">
						<el-input disabled v-model="productForm.scoreDeduction" type="text"></el-input>
					</el-form-item>
				</fieldset>
				
				<el-form-item label="是否上架" prop="upState">
					<el-switch :active-value="1" inactive-color="gray" active-color="red" :inactive-value="0"
						v-model="productForm.upState"></el-switch>
				</el-form-item>
				<el-form-item label="商品规格" prop="goodsSpecs">
					<el-input v-model="productForm.goodsSpecs"></el-input>
				</el-form-item>
				<el-form-item label="商品描述" prop="goodsDescribe">
					<el-input v-model="productForm.goodsDescribe" type="textarea"></el-input>
				</el-form-item>
				<el-form-item label="商品销量" prop="salesVolume">
					<el-input v-model="productForm.salesVolume" type="number" @input="
                            val => {
                                setInt(val, 'salesVolume');
                            }
                        "></el-input>
				</el-form-item>

				<!--放置一个富文本-->
				<el-form-item label="图文详情">
					<div id="graphicDetails"></div>
				</el-form-item>
				<el-form-item style="text-align:right">
					<el-button @click="toCloseProductDialog">取消</el-button>
					<el-button type="primary" @click="submitAddEditProduct">确认</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>

		<!-- 审核商品的弹窗 -->
		<el-dialog title="审核商品" :visible.sync="showProductAuditDialog" width="600px" center
			:close-on-click-modal="false">
			<el-form v-if="showProductAuditDialog" :model="ProductAuditForm" ref="ProductAuditForm"
				:rules="ProductAuditFormRule">
				<!---一个单选组件--->
				<el-form-item label="审核结果" prop="">
					<el-radio-group v-model="ProductAuditForm.checkState">
						<el-radio :label="1">拒绝</el-radio>
						<el-radio :label="2">通过</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item v-if="ProductAuditForm.checkState == 1" label="请输入审核不通过的原因" prop="checkRemark">
					<el-input type="textarea" v-model="ProductAuditForm.checkRemark" placeholder="请输入审核不通过的原因">
					</el-input>
				</el-form-item>
				<el-form-item style="text-align:right">
					<el-button @click="closeProductAudit">取消</el-button>
					<el-button type="primary" @click="submitProductAudit">确认</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>

		<!-- 查看大图 -->
		<!-- <preview-img :previewPath="previewPath" :toggleImg="toggleImg" @close="toggleImg = false"></preview-img> -->
	</div>
</template>
<script>
	let editor = null;
	import E from "wangeditor";
	export default {
		name: "Recommend",
		props: [],
		data() {
			return {
				ProductAuditForm: {
					checkState: 2, // 默认是通过
					checkRemark: '', // 拒绝审核的原因
				},
				id:null,
				ProductAuditFormRule: {
					checkState: [{
						required: true,
						message: "请选择审核结果",
						trigger: "change"
					}],
					checkRemark: [{
						required: true,
						message: "请填写审核不通过的原因",
						trigger: "change"
					}],
				},
				// 商品分类
				catogoryList: [],
				dialogVisible: false, // 查看大图的展示
				dialogImageUrl: null, // 查看大图的链接
				// 商品的表单信息
				productForm: {
					goodsName: "", // 商品名称
					needScore: "", // 所需积分
					scoreDeduction: null, // 积分抵扣
					marketPrice: null, // 市场价
					discountPrice: null, // 销售价
					discountPriceNew: null, // 优惠换购价
					salesVolume: 0, // 销量
					// goodsType: "", // 商品类型
					// freeShipping: "", // 是否包邮
					upState: 0, // 是否上架
					goodsDescribe: "", // 商品描述
					goodsSpecs: "", // 商品规格
					goodsDetail: "" // 图文详情
				},
				productFormRule: {
					goodsName: [{
						required: true,
						message: "商品名称 不能为空",
						trigger: "change"
					}],
					needScore: [{
						required: true,
						message: "所需积分 不能为空",
						trigger: "change"
					}],
					scoreDeduction: [{
						required: true,
						message: "积分抵扣 不能为空",
						trigger: "change"
					}],
					marketPrice: [{
						required: true,
						message: "市场价 不能为空",
						trigger: "change"
					}],
					discountPrice: [{
						required: true,
						message: "销售价 不能为空",
						trigger: "change"
					}],
					// 2021-07-30 用于辅助的字段
					discountPriceNew: [{
						required: true,
						message: "积分换购价 不能为空",
						trigger: "change"
					}],

					goodsType: [{
						required: true,
						message: "商品类型 不能为空",
						trigger: "change"
					}],
					// freeShipping: [
					//     {
					//         required: true,
					//         message: "是否包邮 不能为空",
					//         trigger: "change"
					//     }
					// ],
					upState: [{
						required: true,
						message: "是否上架 不能为空",
						trigger: "change"
					}],
					// goodsDescribe: [
					//     {
					//         required: true,
					//         message: "商品描述 不能为空",
					//         trigger: "change"
					//     }
					// ],
					salesVolume: [{
						required: true,
						message: "商品销量 不能为空",
						trigger: "change"
					}],
					// goodsSpecs: [
					//     {
					//         required: true,
					//         message: "商品规格 不能为空",
					//         trigger: "change"
					//     }
					// ],
					shopId: [{
						required: true,
						message: "所属店铺 不能为空",
						trigger: "change"
					}],
					classId: [{
						required: true,
						message: "所属店铺分类 不能为空",
						trigger: "change"
					}],
				},
				isAdd: true, // 是否是新增
				showProductDialog: false, // 展示商品新增/编辑的弹窗
				userTypes: [],
				searchParams: {},
				formOptions: [

					{
						label: "商品名称",
						prop: "goodsName",
						element: "el-input"
					},
					{
						label: "是否上架",
						prop: "upState",
						element: "el-select",
						options: [{
								label: "上架",
								value: 1
							},
							{
								label: "下架",
								value: 0
							}
						]
					},
				
				],
				tableColumns: [{
						title: "序号",
						index: true,
						fixed: "left"
					},
					{
						key: "",
						title: "操作",
						align: "center",
						operate: true,
						width: 145,
						fixed: "left",
						setBtns: (row, index) => {
							let btns = [];
							btns.push({
								label: "编辑",
								type: "primary",
								handler: (row, index) =>
									this.editProduct(row, index, "edit")
							});
							if (row.upState == 1) {
								btns.push({
									label: "下架",
									type: "danger",
									handler: (row, index) =>
										this.editProduct(
											row,
											index,
											"setUpState",
											0
										)
								});
							} else if (row.upState == 0) {
								btns.push({
									label: "上架",
									type: "success",
									handler: (row, index) =>
										this.editProduct(
											row,
											index,
											"setUpState",
											1
										)
								});
							}
							if (row.checkState == 0) {
								btns.push({
									label: "商品审核",
									type: "success",
									handler: (row, index) =>
										this.editProduct(
											row,
											index,
											"auditProduct",
											1
										)
								});
							}

							return btns;
						}
					},
					// {
					// 	key: "checkState",
					// 	width: 80,
					// 	title: "审核状态",
					// 	render: (h, {
					// 		row
					// 	}) => {
					// 		return h("span", row.checkState == 0 ? "待审核" : (
					// 			row.checkState == 1 ? "审核不通过" : "审核通过"
					// 		));
					// 	}
					// },
					{
						key: "goodsName",
						title: "商品名称"
					},
					{
						key: "salesVolume",
						title: "销量",
						width: 80
					},
					{
						key: "imgUrls",
						slot: true,
						slotName: "imgUrls",
						title: "商品图",
						width: 90
					},
					{
						key: "needScore",
						title: "所需积分",
						width: 80
					},
					{
						key: "scoreDeduction",
						title: "积分抵扣",
						width: 80
					},
					{
						key: "marketPrice",
						title: "市场价",
						width: 80
					},
					{
						key: "discountPrice",
						title: "销售价",
						width: 80
					},
					// {
					// 	key: "shopName",
					// 	title: "所属店铺",
					// 	width: 80
					// },
					// {
					// 	key: "className",
					// 	title: "店铺分类",
					// 	width: 80
					// },
					// {
					// 	key: "typeName",
					// 	title: "商品类型",
					// 	width: 80
					// },
					// {
					//     key: "freeShipping",
					//     title: "是否包邮",
					//     render: (h, { row }) => {
					//         return h(
					//             "span",
					//             row.freeShipping == 1 ? "包邮" : "不包邮"
					//         );
					//     }
					// },
					{
						key: "upState",
						width: 80,
						title: "是否上架",
						render: (h, {
							row
						}) => {
							return h("span", row.upState == 1 ? "上架" : "下架");
						}
					},
					{
						key: "goodsDescribe",
						title: "商品描述"
					},
					{
						key: "goodsSpecs",
						title: "商品规格"
					},

					// {
					// 	key: "checkTime",
					// 	width: 130,
					// 	title: "审核时间",
					// 	render: (h, {
					// 		row
					// 	}) => {
					// 		return h(
					// 			"span",
					// 			this.$util.dateUtil.formatTime(
					// 				row.checkTime,
					// 				"Y-M-D h:m"
					// 			)
					// 		);
					// 	}
					// },
					// {
					// 	key: "checkRemark",
					// 	width: 120,
					// 	title: "审核不通过的原因"
					// },
				],

				pageConfig: {
					total: 0,
					pageSize: 100,
					currentPage: 1
				},
				bottomHandleArr: [{
						label: "新增",
						handler: () => this.addProduct()
					}
					// {
					//     label: "导出",
					//     handler: () => this.exportTable()
					// }
				],
				loading: false,
				showPage: false,
				toggleImg: false,
				previewPath: '',
				dataList: [], //订单列表
				searchParams: {},
				togglePage: false, //是否显示分页
				fileList: [
					// {url:"http://www.zglljc.com/uploads/image/20210329/3e5c2375bda5d8b8478e10420a1ebd33.jpg",name:"测试商品"},
				], // 已经上传的图片列表
				shopList: [], // 店铺的列表
				classList: [], // 店铺对应分类的列表 
				currentRow: {}, // 当前操作的数据
				showProductAuditDialog: false, // 显示商品的审核
			};
		},
		computed: {
			userInfo() {
				let val = sessionStorage.getItem("userInfo");
				return val ? JSON.parse(val) : {};
			},
		},
		created() {},
		methods: {
			// 关闭产品审核的弹窗
			closeProductAudit() {

			},
			// 提交店铺审核
			submitProductAudit() {
				let data = {
					"id": this.currentRow.id,
					"checkState": this.ProductAuditForm.checkState, //0：待审核，1：已拒绝，2：已通过
					"checkRemark": this.ProductAuditForm.checkRemark
				}
				this.$server.codeMall.auditProduct(data, (res) => {
					if (res.code == 0) {
						this.$message.success("操作成功")
						this.showProductAuditDialog = false;
						// 刷新列表
						this.searchList();
					}
				})
			},
			// // 获得店铺列表
			// getShopList() {
			// 	this.$server.system.shopList({}, (res) => {
			// 		if (res.code == 0) {
			// 			this.shopList = res.data.records;
			// 			// 查询条件更新
			// 			this.formOptions[3].options = res.data.records;
			// 		} else {
			// 			this.$message(res.message)
			// 		}
			// 	})
			// },
			// 根据店铺id获取分类
			getClassByShopId(id) {
				this.$server.codeMall.getShopCatogory({
					shopId: id
				}, (res) => {
					if (res.code == 0) {
						console.log(res, 'res')
						this.classList = res.data;
						if (this.classList.length == 0) {
							this.$message.warning("请给当前的店铺添加分类")
						}
					}
				})
			},
			showAllImg(imgIn) {
				let img = this.getFirstImg(imgIn)
				this.previewPath = img;
				this.toggleImg = true;
			},
			// 获取首图
			getFirstImg(imgStrs) {
				let arr = imgStrs.split(",");
				return arr[0] || '';
			},
			// 设置积分的抵扣
			setScoreDeduction(val, word) {
				// 销售价与原价都至少大于零
				if (val < 0) {
					this.productForm[word] = 0.01;
				}
				// 积分换购价 不能大于售价
				if (this.productForm.discountPriceNew - 0 > this.productForm.discountPrice - 0) {
					this.productForm.discountPriceNew = this.productForm.discountPrice;
				}
				let oldVal = this.productForm.discountPrice || 0;
				let newVal = this.productForm.discountPriceNew || 0;
				console.log({
					oldVal: oldVal,
					newVal: newVal
				});
				this.productForm.scoreDeduction = oldVal - newVal;
			},
			// 编辑商品
			
			editProduct(row, index, type, setVal = 0) {
				// 设置一个id用来判断是否是编辑还是新增
				this.id = row.id
				//type ： setUpState -- 设置上下架
				if (type == "setUpState") {
					row.upState = setVal;
					this.upDateProduct(row);
				} else if (type == "auditProduct") {
					// 审核商品
					this.currentRow = {
						...row
					};
					this.showProductAuditDialog = true;
				} else {
					if (!row.id) {
						this.$message("找不到该条数据，请刷新重试")
						return
					}

					this.$loading({
						text: "详情加载中，请稍后"
					});
					this.$server.system.productDetail(row.id, (res) => {
						console.log(row.id)
						console.log(res.code)
						this.$loading().close();
						if (res.code == 0) {
							res.data.discountPriceNew =Math.round(( (res.data.discountPrice || 0) - (res.data.scoreDeduction ||
								0))*100)/100;
							this.productForm = {
								...res.data
							};
							// 计算积分优惠价
							if (res.data.shopId) {
								// 根据已经配置的店铺id获取分类的列表
								this.getClassByShopId(res.data.shopId)
							}
							// 图片
							console.log("开始构造图片", res.data.imgUrls)
							let arr = res.data.imgUrls ? res.data.imgUrls.split(",") : [];
							// 先置空
							this.fileList = [];
							console.log(arr, '图片')
							if (arr.length > 0) {
								arr.forEach((item) => {
									let obj = {};
									obj.name = new Date().getTime(),
										obj.url = item
									console.log(obj, 'obj')
									this.fileList.push(obj)
								})
							}
							this.showProductDialog = true;
							this.$nextTick(item => {
								this.initEditor(row)

							});
						} else {
							this.$message(res.message)
						}
					})
				}
			},
			// 新增商品
			addProduct(row) {
				// this.getShopList(); // 店铺列表
				// 新增的时候清空上传组件
				this.fileList = []; // 测试的时候暂时不清除

				this.productForm = {
					goodsName: "", // 商品名称
					needScore: "", // 所需积分
					scoreDeduction: null, // 积分抵扣
					marketPrice: null, // 市场价
					discountPrice: null, // 销售价
					discountPriceNew: null, // 优惠换购价
					salesVolume: 0, // 销量
					// goodsType: "", // 商品类型
					// freeShipping: "", // 是否包邮
					upState: 0, // 是否上架
					goodsDescribe: "", // 商品描述
					goodsSpecs: "", // 商品规格
					goodsDetail: "" // 图文详情
				};
				this.isAdd = true;
				if (row) {
					this.isAdd = false;
					// 给 productForm 赋值
				}
				this.showProductDialog = true;
				this.$nextTick(() => {
					// 重置表单的校验规则
					// this.$refs.productForm.resetFields();
					this.initEditor()
				});
			},
			initEditor(row) {
				editor = new E("#graphicDetails");
				// 或者 const editor = new E( document.getElementById('div1') )
				editor.config.uploadImgHeaders = {
					token: localStorage.getItem('token')
				}
				editor.config.uploadFileName = 'file'
				editor.config.uploadImgAccept = ['jpg', 'jpeg', 'png', 'gif']
				if (process.env.NODE_ENV == 'development') {
					editor.config.uploadImgServer = '/api/file/upload'
				} else {
					editor.config.uploadImgServer = '/admin/file/upload'
				}
				// editor.config.uploadImgServer = '/file/full/upload'
				editor.config.uploadImgHooks = {
					// 图片上传并返回了结果，想要自己把图片插入到编辑器中
					// 例如服务器端返回的不是 { errno: 0, data: [...] } 这种格式，可使用 customInsert
					customInsert: function(insertImgFn, result) {
						// result 即服务端返回的接口
						console.log('customInsert', result)

						// insertImgFn 可把图片插入到编辑器，传入图片 src ，执行函数即可
						insertImgFn(result.data.url)
					}
				}
				editor.create();
				// 如果是编辑，则渲染富文本的内容
				if (row) {
					editor.txt.html(row.goodsDetail);
				}
			},
			upDateProduct(row) {
				if(this.id){
					row.id = this.id
					this.$server.system.productUpdate(row, res => {
						console.log(res)
						if (res.code == 0) {
							this.showProductDialog = false;
							this.$message.success(row.id ? "编辑成功" : "新增成功");
							this.$refs.commonSearch.onSearch();
						} else {
							this.$message(res.message);
						}
					});
				}else{
				console.log(row)
				this.$server.system.productAddEdit(row, res => {
					console.log(res)
					if (res.code == 0) {
						this.showProductDialog = false;
						this.$message.success(row.id ? "编辑成功" : "新增成功");
						this.$refs.commonSearch.onSearch();
					} else {
						this.$message(res.message);
					}
				});	
				}
			
			},

			// 设置整型的数据
			setInt(val, word) {
				if (String(Number(val)) == "NaN") {
					val = 1;
				} else {
					val = parseInt(val);
				}
				this.$set(this.productForm, word, val);
			},
			// 上传商品的banner
			bannerUpload(file) {
				console.log(file);
				const formData = new FormData();
				formData.append("file", file.file);
				this.$server.material.upFile(formData, res => {
					console.log(res, 'res')
					this.$set(this.fileList, this.fileList.length, {
						name: new Date().getTime(),
						url: res.data.url
					});
					// this.$set(this.bannerForm, "imagesUrl", res.data.url);
				});
				console.log(this.fileList, "上传的图数据");
			},
			// 查看大图
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisible = true;
			},
			// 移除图片
			handleRemove(file, fileList) {
				// console.log(fileList, "fileList");
				// console.log(this.fileList, "this.fileList");
				console.log(file, fileList);
				let index = this.fileList.findIndex((item) => {
					return item.name == file.name
				});
				this.fileList.splice(index, 1)
			},

			// 确认编辑商品
			submitAddEditProduct() {
				if (this.fileList.length == 0) {
					this.$message.warning("请至少上传一张商品图片");
					return
				}
				this.$refs.productForm.validate(valid => {
					let row = {
						...this.productForm
					};
					// // 用于测试，快速添加数据  --- 非测试场景请注释
					// row.id = '';


					// if(!row.id){
					//     // 这部分只是线下用于测试的
					//     let imgUrls = [
					//         "https://tanda.zxyun119.com/admin/file/full/download/RY28M5ZCt5/png",
					//         "https://tanda.zxyun119.com/admin/file/full/download/RY28M5ZCt5/png",
					//         "https://tanda.zxyun119.com/admin/file/full/download/RY28M5ZCt5/png"
					//     ];
					//     row.imgUrls = imgUrls.join(",")
					// }else{
					// }

					let str = '',
						arr = [];
					this.fileList.forEach(item => {
						arr.push(item.url)
					})
					str = arr.join(",")
					row.imgUrls = str;
					row.goodsDetail = editor.txt.html();
					this.upDateProduct(row);
				});
			},

			// 关闭商品编辑的弹窗
			toCloseProductDialog() {
				this.showProductDialog = false;
				editor.destroy();
				editor = null;
			},
			sizeChange(size) {
				this.pageConfig.currentPage = 1;
				this.pageConfig.pageSize = size;
				this.searchList();
			},
			currentChange(currentPage) {
				this.pageConfig.currentPage = currentPage;
				this.searchList();
			},
			exportTable() {
				let that = this;
				if (this.dataList.length < 1) {
					that.$toast.stMessage("暂无订单", true);
					return;
				}
				let pages = {};
				pages.size = this.pageConfig.pageSize;
				pages.current = this.pageConfig.currentPage;
				const sendData = {
					...this.searchParams,
					exportColumnFiledNames: this.tableColumns
						.map(item => {
							return item.key;
						})
						.filter(item => {
							return item && item.trim();
						})
				};
				sendData.beginTime = sendData.beginTime ?
					new Date(sendData.beginTime).getTime() :
					"";
				sendData.endTime = sendData.endTime ?
					new Date(sendData.endTime).getTime() :
					"";
				Object.assign(sendData, pages);
				this.$server.common.exportTable(
					"/appuser/recommendExport",
					sendData,
					res => {
						console.log("导出成功");
					}
				);
			},
			argImg(src) {
				this.previewPath = src;
				this.toggleImg = true;
			},
			onSearch(val) {
				console.log(val, "val");
				val = Object.assign({}, val);
				val.beginDate = val.createTimeArr ?
					new Date(val.createTimeArr[0]) :
					null;
				val.endDate = val.createTimeArr ?
					new Date(val.createTimeArr[1]) :
					null;
				this.searchParams = Object.assign({}, this.searchParams, val);
				this.searchList(true);
			},
			searchList(flag) {
				let pages = {};
				pages.size = this.pageConfig.pageSize;
				pages.current = this.pageConfig.currentPage;
				if (flag) pages.current = 1;
				let searchParams = this.searchParams;
				this.loading = true;
				Object.assign(searchParams, pages);
				this.getData(searchParams);
			},

			getData(data) {
				this.$server.system.productList(data, res => {
					console.log(res)
					this.loading = false;
					if (res.code == 0) {
						this.dataList = res.data.records;
						this.pageConfig.total = res.data.total;
						this.pageConfig.currentPage = res.data.current;
						if (res.data.total > 0) {
							this.togglePage = true;
						}
					}
				});
			},
			// 审核
			setAudit() {
				let that = this;
				if (this.selectedList.length < 1) {
					that.$toast.stMessage("请选择订单", true);
					return;
				}
				let listId = [];
				if (this.selectedList.length > 0) {
					this.selectedList.forEach(item => {
						listId.push(item.id);
					});
				}
				this.$server.material.audit(listId, res => {
					if (res.code == 0) {
						that.$toast.stMessage("审核通过", true);
						that.searchList();
					} else {
						that.$toast.stMessage(res.message, false);
					}
				});
			},
			selectionChange(row) {
				this.selectedList = row;
			},
			cellClass(row) {
				if (row.columnIndex === 0) {
					return "disabledCheck";
				}
			}
		},
		mounted() {
			// this.getShopList(); // 要作为查询条件
			// this.$server.codeMall.productType({}, res => {
			// 	console.log(res, "商品类别");
			// 	if (res.code == 0) {
			// 		this.catogoryList = res.data;
			// 		this.formOptions[2].options = res.data;
			// 	}
			// });

			this.$refs.commonSearch.onSearch();
		}
	};
</script>
<style scoped lang="scss">
	.st-main-content {
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
	}

	.activity-content {
		border: 1px solid red;

		legend {
			font-size: 12px;
			margin-left: 12px;
			color: red;
		}
	}

	.data-table-box {
		height: auto;
		background: #fff;
		padding: 8px;
		box-sizing: border-box;
	}

	.data-table {
		margin-bottom: 8px;
	}

	.query-setting-box-left {
		flex-grow: 0;
	}

	.previewImg {
		position: fixed;
		width: 100%;
		height: 100%;
		left: 0;
		top: 0;
		background-color: rgba(0, 0, 0, 0.5);
		z-index: 99;
	}

	.previewImgWarp {
		position: absolute;
		left: 50%;
		top: 50%;
		margin-left: -300px;
		margin-top: -300px;
		width: 600px;
		height: 600px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.mypreviewImg {
		display: inline-block;
		border: 5px solid #fff;
		border-radius: 3px;
		overflow: hidden;
	}

	.mypreviewImg img {
		max-width: 600px;
	}

	.closeImg {
		position: absolute;
		top: 20px;
		right: 20px;
		cursor: pointer;
	}

	#productDialog /deep/ .el-dialog {
		margin-top: 15px !important;
	}

	.smallImg {
		height: 30px;
	}
</style>
